module.exports = __webpack_public_path__ + "images/rain.2a0971dca36ac735e8cc0814f292a6a1.png";